<template>
  <header class="Header">
    <a
      href="https://www.tichalinka.cz/"
      class="HeaderLeft"
    >
      <span class="sr-only">
        Tichá linka
      </span>
      <LogoSvg />
    </a>

    <div class="HeaderRight">
      <slot>
        <PublicCta v-if="breakpointGreaterLg" />
        <div
          v-else-if="$i18n.locale !== 'ua'"
          class="flex items-center"
          @click="useDialogStore().open('confirmEmergency')"
        >
          <span class="text-danger-500 font-semibold mr-3">
            SOS linka
          </span>
          <el-button
            type="danger"
            circle
          >
            <span class="sr-only">
              Zavolat SOS
            </span>
            <icon-emergency />
          </el-button>
        </div>
      </slot>
    </div>
  </header>
</template>

<script setup>
import LogoSvg from '~/assets/img/logo.svg';

const breakpointGreaterLg = useBreakpoint.greater('lg');
</script>

<style scoped>
@reference "assets/css/tailwind.css";

.Header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 24px 30px;

  @media (max-width: theme(--breakpoint-md)) {
    border-bottom: 1px solid var(--color-light);
    padding: 12px 16px;
  }

  .HeaderLeft {
    @apply text-primary-500;

    @media (max-width: theme(--breakpoint-sm)) {
      svg {
        width: 140px;
        display: block;
      }
    }
  }

  .HeaderRight {
    a {
      @media (max-width: theme(--breakpoint-sm)) {
        text-decoration: underline;
      }
    }
  }
}
</style>
